import { atom } from "recoil";

const cashState =atom({
    key: 'cash',
    default: ''
})

export default cashState